<div style="display:flex; justify-content:flex-start; align-items:center" class="flexposition">
  <vng-icon name="search" [outline]="false" class="search-icon"></vng-icon>
  <div class="search-input-wrap">
    <input
      type="text"
      placeholder="Search All of FlyMSG"
      class="search-field dis_ex fly-msg-ignore"
      role="combobox"
      aria-haspopup="listbox"
      aria-autocomplete="list"
      [attr.aria-expanded]="panelOpen && !advancedSearch"
      [attr.aria-controls]="panelOpen && !advancedSearch ? 'global-search-listbox' : null"
      [attr.aria-activedescendant]="activeOptionId"
      [formControl]="myControl"
      (keydown)="keyDownFunction($event)"
      (focus)="onInputFocus()"
      (focusout)="onInputFocusOut($event)"
      style="padding-right: 43px"
    />
    <!-- R20: global search results panel — trivial-HTML replacement for
         mat-autocomplete (proven sibling pattern, flymsg-admin-fe's migrated
         top-search-bar.component.html), grouped results via .optgroup-label,
         no vng-autocomplete (see 03-component-mapping.md R20). -->
    <div
      class="autocomplete-panel"
      id="global-search-listbox"
      role="listbox"
      aria-label="Search results"
      [style.display]="advancedSearch || !panelOpen ? 'none' : 'block'"
    >
      <!-- H3: the spinner sits OUTSIDE the async-gate (so it shows during the
           very first request) and overlays the possibly-stale list instead of
           replacing it — the list is no longer gated on isLoading. -->
      <div *ngIf="isLoading && !advancedSearch" class="is-loading">
        <vng-spinner [diameter]="25"></vng-spinner>
      </div>
      <ng-container *ngIf="filteredOptions | async as filteredOptions">
        <ng-container *ngIf="!advancedSearch">
          <div style="margin: 0; padding: 0">
            <div *ngFor="let group of filteredOptions; let gi = index" class="optgroup" role="group" [attr.aria-label]="group.type">
              <div class="optgroup-label">{{ group.type }}</div>
              <div
                *ngFor="let item of group.items; let ii = index"
                class="option"
                role="option"
                [id]="'global-search-option-' + flatIndex(gi, ii)"
                [attr.aria-selected]="flatIndex(gi, ii) === highlightedIndex"
                [class.option--active]="flatIndex(gi, ii) === highlightedIndex"
                (mouseenter)="highlightedIndex = flatIndex(gi, ii)"
                (click)="clickOption(item)"
              >
                {{ item.shortcut }}
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <vng-icon name="tune" [outline]="false" class="pointer tune-icon" (click)="toggleAdvanced()"></vng-icon>

  <div
    class="icon-box"
    [ngClass]="{ 'icon-box-active': !firstThreeComplete }"
    vngTourAnchor="step19"
    data-fms-heap="header-onboarding"
  >
    <svg-icon-sprite
      *ngIf="progresshow"
      width="32px"
      height="23px"
      src="icon-progress-bar"
      (click)="gotToOnboarding()"
      [vngTooltip]="'Onboarding'"
      vngTooltipPosition="top"
      class="cap-icon"
    >
    </svg-icon-sprite>
  </div>
  <!-- variant="accent": master rendered this bar in brand orange; the vng
       default variant is primary purple, which read as a color regression.
       Geometry: mat-progress-bar took its height/radius straight off the host
       element, vng-progress-bar does not — the inner `.vng-progress-bar__track`
       reads `--vng-progress-bar-height`/`--vng-progress-bar-radius` instead, so
       `style="height: 12px; border-radius: 28px"` was silently doing nothing and
       the bar rendered at the token default. `size="lg"` is also dropped: its
       `:host(.vng-progress-bar--lg) .vng-progress-bar__track { height: 10px }`
       rule out-specifies the token and would pin the bar back to 10px. -->
  <vng-progress-bar
    *ngIf="progresshow"
    mode="determinate"
    variant="accent"
    [value]="progressValue"
    style="--vng-progress-bar-height: 12px; --vng-progress-bar-radius: 28px; width: 130px"
  >
  </vng-progress-bar>
  <span *ngIf="progresshow" style="margin-left: 7px; font-size: 16px">{{ progressValue }}%</span>
</div>
<div vngTourAnchor="stepFake"></div>
